export default {
  intro: 'Please follow the steps on the payment terminal on your right side.',
};
